export default (initialTab: string) => ({
  activeTab: initialTab,
  ready: false,
  _observer: null as IntersectionObserver | null,
  _resizeHandler: null as (() => void) | null,

  init() {
    const requestedTab = new URLSearchParams(window.location.search).get('tab')

    if (requestedTab && this.tabIds().includes(requestedTab)) {
      this.switchTab(requestedTab)
    }

    this.$nextTick(() => {
      this.movePill(this.activeTab)
      this.$nextTick(() => this.ready = true)
    })

    this.$watch('activeTab', (id: string) => this.movePill(id))

    this._observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.snapPill()
    })

    this._observer.observe(this.$el)

    this._resizeHandler = () => this.snapPill()
    window.addEventListener('resize', this._resizeHandler)
  },

  destroy() {
    this._observer?.disconnect()
    this._resizeHandler && window.removeEventListener('resize', this._resizeHandler)
  },

  tabIds(): string[] {
    return Array.from(this.$el.querySelectorAll('[role="tab"]'))
      .map((tab) => (tab as HTMLElement).id.replace(/^tab-/, ''))
      .filter(Boolean)
  },

  switchTab(id: string) {
    this.activeTab = id
    this.$el.dispatchEvent(new CustomEvent('tab-change', {
      detail: { tab: id },
      bubbles: true,
    }))
  },

  snapPill() {
    const pill = this.$refs.navPill as HTMLElement | undefined

    if (!pill) return

    pill.style.transition = 'none'
    this.movePill(this.activeTab)
    pill.offsetWidth
    pill.style.transition = ''
  },

  movePill(id: string) {
    const btn = this.$el.querySelector(`#tab-${id}`) as HTMLElement | null
    const pill = this.$refs.navPill as HTMLElement | undefined

    if (btn && pill) {
      pill.style.left = `${btn.offsetLeft}px`
      pill.style.width = `${btn.offsetWidth}px`
    }
  },
})
